import { SET_SELLER_STOCKS, SET_SELLER_STOCKS_LOADING, SET_SELLER_STOCKS_ERROR, SET_SELLER_STOCKS_SAVING } from "../../actions/sellerStockAction";

const initialState = { data: null, loading: false, saving: false, error: null };
export default function sellerStockReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELLER_STOCKS: return { ...state, data: action.value, error: null };
    case SET_SELLER_STOCKS_LOADING: return { ...state, loading: action.value, ...(action.value ? { data: null, error: null } : {}) };
    case SET_SELLER_STOCKS_SAVING: return { ...state, saving: action.value };
    case SET_SELLER_STOCKS_ERROR: return { ...state, data: null, error: action.value };
    default: return state;
  }
}
